import { useTranslation } from "react-i18next";
import { type WorkflowStepInput } from "~/api/types";
import { Label } from "~/atoms/label";
import { WorkflowBuilder } from "~/organisms/WorkflowBuilder";
import { type WorkflowEditorMode } from "~/pages/workflow-editor/useWorkflowEditorPage";

interface Props {
  mode: WorkflowEditorMode;
  setSteps: React.Dispatch<React.SetStateAction<WorkflowStepInput[]>>;
}

export function WorkflowStepsSection({ mode, setSteps }: Props) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2">
      <div>
        <Label>{t(($) => $.commons.workflow.steps)}</Label>
        <p className="text-muted-foreground text-xs">
          {t(($) => $.commons.workflow.stepsDescription)}
        </p>
      </div>
      <WorkflowBuilder
        isEditMode={mode.type === "editing"}
        workflow={mode.workflow}
        steps={mode.steps}
        setSteps={setSteps}
        setHasUnsavedChanges={() => undefined}
      />
    </div>
  );
}
